import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  AcuerdoAmbitoGeograficoControllerService,
  AcuerdoAmbitoGeograficoDTO,
  AcuerdoAmbitoGeograficoFilterDTO,
  AcuerdoIndirectoControllerService,
  CodigoLerControllerService,
  CodigoLerFilterDTO,
  ComunidadControllerService,
  PageDTOAcuerdoAmbitoGeograficoDTO,
} from 'api-rest'
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GeographicScopeDialogComponent } from '../geographic-scope-dialog/geographic-scope-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'managers-agreements-detail-geographic-scope',
  templateUrl: './detail-geographic-scope.component.html',
  styleUrls: ['./detail-geographic-scope.component.scss']
})
export class DetailGeographicScopeComponent implements OnInit {

  @Input() acuerdoIndirectoInfo!: any;
  @Input() soloLectura = false;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();


  pageNumber: number = 1;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;

  gridArray: AcuerdoAmbitoGeograficoDTO[] = [];
  searchForm: FormGroup;
  flagSearch: boolean = false;

  searchControl: FormControl = new FormControl();
  filteredComunidades: any[] = [];
  comunidadArray: any[] = [];
  codigoLerArray: any[] = [];

  

  headArray: any = [
    {
      Head: 'Comunidad',
      FieldName: 'comunidad',
      Attribute: 'nombre',
    },
    {
      Head: 'Códigos LER Autorizados',
      FieldName: 'codigoLer',
      Tooltip: true,
      width: '28',
      renderValue: (item: any) =>
        this.truncateText(this.getCodigoLerLabel(item), 55),
    },
    {
      Head: 'Cantidades anuales acordadas (t)',
      FieldName: 'cantidad_t',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'edit', icon: 'open_in_new', toolTip: 'Editar' , show: { params: 'canAccessDelete', accion: 'edit' },},
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },

      ],
      width: '8',
      permanent: true,
    },
  ];

  constructor(
    private acuerdoAmbitoGeografico: AcuerdoAmbitoGeograficoControllerService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private formBuilder: FormBuilder,
    private comunidadControllerService: ComunidadControllerService,
    private codigoLerService: CodigoLerControllerService,
    private router: Router,
    private dialog: MatDialog,
    
  
  ) {
    this.searchForm = this.formBuilder.group({
      id: [{ value: null, disabled: false }],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      comunidad_autonoma: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.buscarAmbitoGeografico();
    this.getComboComunidad();
    this.buscaCodigoLer();
  }

  private canDeleteScope(): boolean {
    return !this.soloLectura && this.acuerdoIndirectoInfo?.estado?.id === 1;
  }

  buscarAmbitoGeografico() {
    const filtro: AcuerdoAmbitoGeograficoFilterDTO = {
      acuerdoIndirecto: {
        id: this.acuerdoIndirectoInfo?.id
      },
      codigoLer: this.searchForm.get('codigoLer')?.value
      ? this.searchForm.get('codigoLer')?.value
      : undefined,
      comunidad: {
        id: this.searchForm.get('comunidad_autonoma')?.value
          ? this.searchForm.get('comunidad_autonoma')?.value?.id
          : undefined,
      },
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    this.spinnerSrv.loadingShow();
    this.acuerdoAmbitoGeografico
      .findAll5(filtro, { page: page, size: this.pageSize, sort: ['id,desc'] })
      .subscribe({
        next: (data: PageDTOAcuerdoAmbitoGeograficoDTO) => {
          this.spinnerSrv.loadingHide();
          this.gridArray = (data.datos ?? []).map((item: any) => ({
            ...item,
            canAccessDelete: this.canDeleteScope(),
          }));
          this.recordsTotal = data.paginacion?.totalElements ?? 0;
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al obtener el ámbito geográfico',
            'error'
          );
          console.log(err);
        },
      });
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.buscarAmbitoGeografico();
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscarAmbitoGeografico();
  }

    openModalContact(element?: any): void {
      const dialogRef = this.dialog.open(GeographicScopeDialogComponent, {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          ambitoGeografico: element,
          acuerdoIndirecto: this.acuerdoIndirectoInfo,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buscarAmbitoGeografico();
          this.refrescarAdheridoEvent.emit(true);
        }
      });
    }

  action(item: any) {
    if (item.nameButton == 'edit' && !this.soloLectura && this.canDeleteScope()) {
      this.openModalContact(item);
    }else if (item.nameButton == 'delete' && this.canDeleteScope()) {
      this.confirmacionEliminar(item);
    }
  }

  canAccessCreateScope(): boolean {
    return !this.soloLectura && this.acuerdoIndirectoInfo?.estado?.id === 1; 
  }

  private getCodigoLerLabel(item: any): string {
    return item?.codigoLer
      ? `${item.codigoLer.tipoCodigo} - ${item.codigoLer.descripcion}`
      : '';
  }

  private truncateText(value: string, maxLength: number): string {
    if (!value) {
      return '';
    }

    return value.length > maxLength
      ? `${value.slice(0, maxLength).trimEnd()}...`
      : value;
  }

  buscaCodigoLer() {
      const filtroNimaPoseedor: CodigoLerFilterDTO = {
        acuerdoGestores: true
      };
      this.spinnerSrv.loadingShow();
      this.codigoLerService.findAll4(filtroNimaPoseedor, { page: 0, size: 1000 }).subscribe({
        next: (res) => {
          this.codigoLerArray = res?.datos || [];
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  } 
  

  getComboComunidad() {
    this.comunidadControllerService
      .listarComunidades3({}, { page: 0, size: 500, sort: [] })
      .subscribe({
        next: (data: any) => {
          this.comunidadArray = data.datos!;
          this.filteredComunidades = this.comunidadArray;
        },
        error: () => {},
      });
  }

    filterComunidades(searchTerm: any) {
    if (searchTerm) {
      this.filteredComunidades = this.comunidadArray.filter((comunidad) =>
        comunidad.nombre.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      this.filteredComunidades = this.comunidadArray;
    }
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  
  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  searchData() {
    this.pageNumber = 1;
    this.buscarAmbitoGeografico();
  }

  obtenerAcuerdosIndirectos() {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    this.spinnerSrv.loadingShow();
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const filtro: any = {
        id: this.searchForm.get('id')?.value
        ? Number(this.searchForm.get('id')?.value)
        : undefined,
      codigoDocumento: this.searchForm.get('codigo_documento')?.value
        ? this.searchForm.get('codigo_documento')?.value.trim()
        : undefined,
      razonSocial: this.searchForm.get('razon_social')?.value
        ? this.searchForm.get('razon_social')?.value.trim()
        : undefined,
      estado: this.searchForm.get('estado')?.value ?? undefined,
    };

    this.acuerdoAmbitoGeografico
      .findAll5(filtro, { page: page, size: this.pageSize, sort: [] })
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          this.flagSearch = (data.datos?.length ?? 0) > 0;
          this.gridArray = data.datos ?? [];
          this.recordsTotal = data.paginacion?.totalElements ?? 0;
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Error obteniendo listado de acuerdos indirectos',
            'error'
          );
        },
      });
  }
  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el ámbito?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminar(element);
      }
    });
  }
  eliminar( element?: any) {
    this.acuerdoAmbitoGeografico
      .deleteById3(element.id)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          this.searchData();
          this.snackBarSrv.showSnackBar(
            'Ámbito geográfico eliminado correctamente',
            'success'
          );
          this.refrescarAdheridoEvent.emit(true);
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Error eliminando ámbito geográfico',
            'error'
          );
        },
      });
  }
  hasMultiplePages(): boolean {
    const total = this.recordsTotal ?? 0;
    const size = this.pageSize ?? 0;
    return size > 0 && total > size;
  }
}
